
module.directive('modelDelete', function() {
    return {
        restrict: 'E',
        templateUrl: 'util/forms/modelDelete',
        scope: {
            text: "@",
        },
        link: function(scope, element, attrs) {

            function setDelete(status) {
                element.toggleClass('deleting', status);
                scope.deleting = status;
            }

            scope.doDelete = function(status) {
                scope.deleteCallback();
            };

            scope.startDelete = angular.bind(this, setDelete, true);
            scope.endDelete = angular.bind(this, setDelete, false);
        }
    };
});
